import { useContext } from 'react';
import { BrandingContext, type BrandingContextType } from './branding-context';

export function useBranding(): BrandingContextType {
  const ctx = useContext(BrandingContext);
  if (!ctx) throw new Error('useBranding must be used within BrandingProvider');
  return ctx;
}
